export default __webpack_public_path__ + "static/media/successPay.f02add0c.svg";